<template>
    <div
        v-if="type"
        class="icon"
        :style="getStyles"
        @click="$emit('onClick')">
        <component :is="iconLoader" />
    </div>
</template>

<script>

export default {
    name: 'Icon',
    computed: {
        getStyles () {
            return {
                width: `${this.width}px`,
                height: `${this.height}px`,
            };
        },
        iconLoader () {
            const type = this.type;
            return () => import(`@/components/common/icons/${type}.svg?inline`);
        },
    },
    props: {
        type: {
            type: String,
            required: true,
        },
        width: {
            type: Number,
            default: 24,
        },
        height: {
            type: Number,
            default: 24,
        },
    },
};
</script>

<style scoped lang="scss">
  .icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;

    svg {
      width: auto;
      height: 100%;
    }
  }
</style>
